import { InputLabel, Button } from "@mui/material";
import { useState } from "react";

import AvailabilityHourWindow from "./AvailabilityHourWindow";

export default function AvailabilityTableRow({ day, dayKey, defaultValues, client }) {
  const [formValues, setFormValues] = useState([]);

  const addHourWindow = () => {
    setFormValues([...formValues, { start_time: "", end_time: "" }]);
  };

  const handleCancelEdit = () => {
    setFormValues([]);
  };

  return (
    <div className="m-1 flex flex-col px-1 py-4 shadow-md">
      <InputLabel className="p-1 text-sm font-bold">{day}</InputLabel>
      {defaultValues && defaultValues.length === 0 && formValues && formValues.length === 0 ? (
        <InputLabel className="m-1 rounded-md bg-gray-100 p-1 text-center text-sm">
          {"No Availability"}
        </InputLabel>
      ) : (
        defaultValues.map((item) => {
          return (
            <AvailabilityHourWindow
              key={item.id}
              activeWindow={item}
              handleCancelEdit={handleCancelEdit}
              dayKey={dayKey}
              client={client}
              newField={false}
            />
          );
        })
      )}
      {formValues && formValues.length === 0
        ? ""
        : formValues.map((_, index) => {
            return (
              <AvailabilityHourWindow
                key={index}
                index={index}
                setFormValues={setFormValues}
                formValues={formValues}
                handleCancelEdit={handleCancelEdit}
                dayKey={dayKey}
                client={client}
                newField={true}
              />
            );
          })}

      <Button onClick={() => addHourWindow()} className="m-2">
        Add New Hour
      </Button>
    </div>
  );
}
